import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="navbar-underline"
export default class extends Controller {
  static targets = ["link", "underline"];

  connect() {
    // On load, position underline under the active link
    this.moveUnderlineToActive();
    window.addEventListener('resize', this._resizeHandler = () => this.moveUnderlineToActive());
  }

  disconnect() {
    window.removeEventListener('resize', this._resizeHandler);
  }

  moveUnderlineToActive() {
    const active = this.linkTargets.find(link => link.classList.contains("active"));
    if (active) {
      this.moveUnderline(active);
    }
  }

  moveUnderline(link) {
    const linkRect = link.getBoundingClientRect();
    const parentRect = this.element.getBoundingClientRect();
    const left = linkRect.left - parentRect.left;
    const width = linkRect.width;
    const height = 2;
    // Place underline just below the link text
    this.underlineTarget.style.left = `${left}px`;
    this.underlineTarget.style.width = `${width}px`;
    this.underlineTarget.style.top = `${this.element.offsetHeight - height}px`;
    this.underlineTarget.style.height = `${height}px`;
    this.underlineTarget.style.opacity = 1;
  }

  handleMouseEnter(event) {
    this.moveUnderline(event.currentTarget);
  }

  handleMouseLeave() {
    // Hide underline if no active link, else move to active
    const active = this.linkTargets.find(link => link.classList.contains("active"));
    if (active) {
      this.moveUnderline(active);
    } else {
      this.underlineTarget.style.opacity = 0;
    }
  }
} 